import React from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {NavLink, useLocation} from 'react-router-dom'
import {config} from '../../config'
import moment from "moment";

const Header = ({
  course = {},
  semester = {},
  study_semester = '',
  faculty_design = false,
  faculty_design_segment = '',
}) => {
  const location = useLocation()
  const is_home = location.pathname === config.HOME
  const is_lectures = location.pathname === config.LECTURES
  const is_full_selection = is_lectures && ((course && semester) || faculty_design) && study_semester
  const last_modified = semester => {
    if (semester.last_modified) {
      const m = moment.utc(semester.last_modified)
        .local()
        .format('D.M.YYYY')

      return (
        <span className="small">Stand: {m}</span>
      )
    }
    return ''
  }

  return (
    <>
      <header className="sticky-header">
        <nav className={`navbar navbar-expand-xl py-4 justify-content-between ${!is_home ? 'bg-primary' : ''}  
                ${is_lectures ? ' adjusted-height' : ''}`}
        >
          <div className="container-lg">
            {
              !is_home ? (
                <>
                  <div className="col-10 d-flex align-items-center">
                    {/* Showing the full selection on the lectures page with link to selector. Otherwise, show faculty with link to home. */}
                    <NavLink
                      to={is_full_selection ? config.SELECTOR : config.HOME}
                      state={{fromNavigation: true}}
                      className="arrow-before menu-link align-items-baseline"
                    >
                      {
                        is_full_selection ? (
                          <span>
                            {
                              faculty_design ? (
                                <>
                                  <span className="small strong">Design</span>
                                  <span className="small">{faculty_design_segment.name}</span>
                                </>
                              ) : (
                                <>
                                  <span className="small strong">{course.name}</span>
                                  <span className="small">{semester.name} - {study_semester}</span>
                                  {last_modified(semester)}
                                </>
                              )
                            }
                          </span>
                        ) : (
                          <span className="small strong">Fachbereiche</span>
                        )
                      }
                    </NavLink>
                  </div>
                  {
                    is_lectures && (
                      /* Show direct link to home when in lectures view */
                      <div className="col-2 d-flex justify-content-end">
                        <NavLink
                          to={config.HOME}
                          state={{fromNavigation: true}}
                          className="menu-link icon"
                        >
                          home
                        </NavLink>
                      </div>
                    )
                  }
                </>
              ) : (
                /* Show static text when on the home page */
                <div className="flex-grow-1 text-center">
                  <p className="strong">FHP Vorlesungsverzeichnis</p>
                </div>
              )
            }
          </div>
        </nav>
      </header>
    </>
  )

}

Header.propTypes = {
  semester: PropTypes.object,
  study_semester: PropTypes.string,
  course: PropTypes.object,
}

const mapDispatchToProps = dispatch => ({})

const mapStateToProps = state => ({
  course: state.vvz.course,
  semester: state.vvz.semester,
  study_semester: state.vvz.study_semester,
  faculty_design: state.vvz.faculty_design,
  faculty_design_segment: state.vvz.faculty_design_segment,
})

export default connect(mapStateToProps, mapDispatchToProps)(Header)
